import Api from './Api';

function addBankAccount(user) {
  if (!user) {
    return Promise.reject('Invalid user');
  }

  let payload = Api.Utils.clone(window.plaidPayload);

  let returnValue = new Promise((accept, reject) => {
    let isSuccess = false;
    payload.onSuccess = (public_token, metadata) => {
      let data = {
        public_token: public_token,
        account_id: metadata.account_id
      };

      isSuccess = true;
      Api.plaidTokenViaStripe(data).then(accept, reject);
    };

    payload.onExit = (err, metadata) => {
      if (!isSuccess) reject(metadata);
    };

    let linkHandler = window.Plaid.create(payload);
    linkHandler.open();
  });

  returnValue.then(response => {
    Api.cache.setSelectedInstrument(response.token);
    return Api.getUser();
  });

  return returnValue;
}

function addCreditCard(user) {
  if (!user) {
    return Promise.reject('Invalid user');
  }

  let returnValue = new Promise((accept, reject) => {
    let isTokenReceived = false;

    let stripeHandler = window.StripeCheckout.configure({
      key: window.stripePublicKey,
      image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
      locale: 'English',
      token: function(token) {
        isTokenReceived = true;
        Api.stripeLinkCard(token).then(accept, reject);
      },
      closed: function() {
        if (!isTokenReceived) reject();
      }
    });

    stripeHandler.open({
      name: 'Indigo Fair Inc.',
      description: '',
      panelLabel: 'Link Card',
      allowRememberMe: false,
      zipCode: false,
      billingAddress: false,
      email: user.email_address
    });

    window.addEventListener(
      'popstate',
      function() {
        stripeHandler.close();
        reject();
      },
      {
        once: true
      }
    );
  });

  returnValue.then(response => {
    Api.cache.setSelectedInstrument(response.token);
    return Api.getUser();
  });

  return returnValue;
}

export default { addBankAccount, addCreditCard };



/** WEBPACK FOOTER **
 ** ./src/payments.js
 **/